import { MantineProvider } from '@mantine/core';
import { Theme } from '@carbon/react';

import StoreProvider from './store/StoreProvider';
import useCarbonThemes from './utils/Hooks/useCarbonThemes';
import { theme } from './theme';

import '@mantine/core/styles.css';
import { AuthProvider } from 'router/authentication/AuthProvider';
import Router from 'router/AppRouter';
import I18nProvider from 'i18n';
import InitialHandler from 'Components/InitialHandler/InitialHandler';
import { StripeProvider } from 'Components/StripeProvider';
import { GlobalSnackbar } from 'Components/GlobalSnackbar/GlobalSnackbar';

const App = () => {
    const getTheme = useCarbonThemes();
    return (
        <MantineProvider theme={theme}>
            <StripeProvider>
                <Theme theme={getTheme()}>
                    <StoreProvider>
                        <>
                            <GlobalSnackbar />
                            <AuthProvider>
                                <InitialHandler>
                                    <I18nProvider>
                                        <Router />
                                    </I18nProvider>
                                </InitialHandler>
                            </AuthProvider>
                        </>
                    </StoreProvider>
                </Theme>
            </StripeProvider>
        </MantineProvider>
    );
};

export default App;
